export default __webpack_public_path__ + "static/media/img_16.19aa9ed2.jpg";